import { useState } from 'react';

import { forgotPassword } from '#/api/userEnvironment/apiUserEnvironment';
import type { ForgotPasswordFormValues } from '#/components/ForgotPasswordForm/ForgotPasswordForm';
import { ForgotPasswordForm } from '#/components/ForgotPasswordForm/ForgotPasswordForm';
import type { FormUsageContext } from '#/components/Form/Form';
import type { FormSubmitFunction } from '#/components/Form/FormContext';

type Props = {
  analyticsTitle: string;
  usageContext: FormUsageContext;
  email?: string | null | undefined;
};

export function ForgotPasswordFormContainer({
  analyticsTitle,
  usageContext,
  email,
}: Props) {
  const [emailSent, setEmailSent] = useState(false);

  const submitForgotPassword: FormSubmitFunction<ForgotPasswordFormValues> = ({
    values,
    handleError,
    updateSubmitting,
  }) => {
    forgotPassword(values.email)
      .then(() => {
        updateSubmitting(false);
        setEmailSent(true);
      })
      .catch(handleError);
  };

  return (
    <ForgotPasswordForm
      analyticsTitle={analyticsTitle}
      usageContext={usageContext}
      initialValues={{ email: email ?? '' }}
      emailSent={emailSent}
      submitForgotPassword={submitForgotPassword}
    />
  );
}
